/**
 * The single theme: the `--sm-*` block selected by `data-sm-theme="ics"` in
 * tokens.css. No component is aware of it.
 */

/** Call before mount so the first paint is already in the right theme. */
export function initTheme(): void {
  document.documentElement.dataset.smTheme = 'ics'
}
